import { render, staticRenderFns } from "./addContent.vue?vue&type=template&id=b9c3c804"
import script from "./addContent.vue?vue&type=script&lang=js"
export * from "./addContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports